import { IAplSettings } from "../../redux/helpers/aplSettingsHelper";
import { Culture } from "../../types/culture";
import LabelsPrintBasicButton from "./LabelsPrintBasicButton";

interface LabelsPrintBasicProps {
    isPrinting: boolean;
    lineDescription: string;
    workorder: string;
    materialDescription: string;
    nextSequence: number;
    onPrint: () => void;
    aplSettings: IAplSettings;
    translateString: (key: string, culture: Culture) => string;
}

const LabelsPrintBasic: React.FC<LabelsPrintBasicProps> = ({
    isPrinting,
    lineDescription,
    workorder,
    materialDescription,
    nextSequence,
    onPrint,
    aplSettings,
    translateString
}) => {
    return (
        <div className="container d-flex flex-column align-items-center justify-content-center">
            <div className="p-2 h3 align-items-center">
                <span id="divPrintdetailsBasicA" className="d-flex flex-row align-items-center justify-content-center">
                    {lineDescription} - {translateString("workorder", aplSettings.culture)} {workorder} - 
                    {translateString("nextSeqNo", aplSettings.culture)} {nextSequence}
                </span>
                <span id="divPrintdetailsBasicB" className="d-flex flex-row align-items-center justify-content-center">
                    {materialDescription}
                </span>
            </div>
            <div className="p-2">
                <div id="labels-print-basic" onClick={onPrint}>
                    <LabelsPrintBasicButton isPrinting={isPrinting} />
                </div>{" "}
            </div>
        </div>
    );
};

export default LabelsPrintBasic;
